module.exports = "<div> <m-header :title=header1.title :back-text=header1.backText :back-cb=header1.backCb></m-header> <m-header :title=header1.title></m-header> <m-header> <div style=\"color: red; line-height:44px\">自定义</div> </m-header> <m-header> <div style=line-height:44px slot=left>自定义</div> <div style=\"color: red; line-height:44px\">自定义</div> <div style=line-height:44px slot=right>自定义</div> </m-header> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demos/MHeader.vue
 ** module id = 190
 ** module chunks = 0
 **/